export default {
  getStorageSpace: state => state.storageSpace,
  getSetupArchivePasswordStatus: state => state.setupArchivePasswordStatus,
  getArchiveDeletionStatus: state => state.archiveDeletionStatus,
  getContentItems: state => state.contentItems,
  getFetchStorageSpaceStatus: state => state.fetchStorageSpaceStatus,
  getFetchContentItemsStatus: state => state.fetchContentItemsStatus,
  getActiveContentType: state => state.activeContentType,
  getAppFeatures: state => state.appFeatures,
  getFileVersions: state => state.fileVersions,
  getFetchFileVersionsStatus: state => state.fetchFileVersionsStatus,
  getSignFileLink: state => state.signFileLink,
  getSignFileStatus: state => state.signFileStatus,
  getSearchEnabled: state => state.searchEnabled,
  getSearchResultReceived: state => state.searchResultReceived,
  getActiveVersionPath: state => state.activeVersionPath,
  getActiveVolumePath: state => state.activeVolumePath,
  getActiveFolderItem: state => state.activeFolderItem,
  getFetchContainerItemsStatus: state => state.fetchContainerItemsStatus,
  getMachines: state => state.machines,
  getBackups: state => state.backups,
  getIncompleteBackups: state => state.incompleteBackups,
  getIncompleteBackupsCount: state => state.incompleteBackupsCount,
  getIncompleteBackupsSize: state => state.incompleteBackupsSize,
  getTotalUsedSpace: state => state.totalUsedSpace,
  getActiveMachineId: state => state.activeMachineId,
  getActiveMachineDisplayName: state => state.activeMachineDisplayName,
  getIncompleteBackupsMachineId: state => state.incompleteBackupsMachineId,
  getFetchBackupsStatus: state => state.fetchBackupsStatus,
  getActiveBackupId: state => state.activeBackupId,
  getActiveBackupDisplayName: state => state.activeBackupDisplayName,
  getDeleteAllIncompleteStatus: state => state.deleteAllIncompleteStatus,
  getDisplayUserName: state => state.displayUserName
};
